export const techReadiGoModePrimary = 'tech_redi_go_mode_primary';
export const techReadiGoModeJunior = 'tech_redi_go_mode_junior';
export const techReadiGoMode = 'tech_redi_go_mode';
export const techReadiGoModeOsslt = 'tech_redi_go_mode_osslt';
export const boardTechReadinessCheckPrimary = 'tech_redi_school_board_check_pj_primary';
export const boardTechReadinessCheckJunior = 'tech_redi_school_board_check_pj_junior';
export const boardTechReadinessCheck = 'tech_redi_school_board_check';
export const boardTechReadinessCheckOsslt = 'tech_redi_school_board_check_osslt';
